"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const defaultTheme_1 = require("../../shared/defaultTheme");
const react_i18next_1 = require("react-i18next");
const resolveFactUnit = (key, value, unit) => {
    if (!value && value !== 0)
        return "";
    if (key === "calories")
        return `${value}`;
    return `${value} ${unit}.`;
};
const changeOrderOfFacts = (facts) => {
    // TODO: TS - type casting due to bad implementation
    if (!facts)
        return null;
    return {
        calories: facts.calories,
        carbohydrates: facts.carbohydrates,
        proteins: facts.proteins,
        fats: facts.fats,
        fibers: facts.fibers
    };
};
const BudgetChange = ({ prevBudget, nextBudget, unit }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const prev = changeOrderOfFacts(prevBudget);
    const next = changeOrderOfFacts(nextBudget);
    return ((0, jsx_runtime_1.jsx)(Budget, { children: (0, jsx_runtime_1.jsx)("div", { children: Object.entries(next).map(([key]) => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t(`historyOfChanges.budget.${key}`) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: resolveFactUnit(key, prev && prev[key], unit) }, void 0), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faArrowRight, color: defaultTheme_1.defaultTheme.colors.greyLighten70 }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: resolveFactUnit(key, next[key], unit) }, void 0)] }, key))) }, void 0) }, void 0));
};
const Budget = styled_components_1.default.div `
  padding: ${({ theme }) => `0 ${theme.spacings.xl} ${theme.spacings.m}`};

  h4,
  p {
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  & > div {
    background-color: ${({ theme }) => theme.colors.silverLighten70};
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xxl}`};

    & > div {
      display: flex;
      width: 100%;

      h4 {
        display: inline-block;
        font-weight: 500;
        width: 4.5rem;
      }

      p:first-of-type {
        display: inline-block;
        width: 3.2rem;
      }

      span {
        line-height: 1.5rem;
        padding: ${({ theme }) => `0 ${theme.spacings.m}`};
      }
    }

    & > div:not(:last-of-type) {
      margin-bottom: ${({ theme }) => theme.spacings.xxs};
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => `0 ${theme.spacings.m} ${theme.spacings.m}`};
  }
`;
const Event = ({ unit, event }) => {
    const isCollapsable = !!event.nextBudget;
    const [isCollapse, setIsCollapse] = (0, react_1.useState)(!isCollapsable);
    const toggleIsCollapse = () => setIsCollapse(!isCollapse);
    return ((0, jsx_runtime_1.jsxs)(EventWrapper, { isCollapsable: isCollapsable, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: event.name }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: event.origin }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: event.createdAt }, void 0), isCollapsable && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: isCollapse ? pro_regular_svg_icons_1.faChevronDown : pro_regular_svg_icons_1.faChevronUp, color: defaultTheme_1.defaultTheme.colors.greyLighten70, onClick: toggleIsCollapse }, void 0))] }, void 0)] }, void 0), isCollapsable && !isCollapse && ((0, jsx_runtime_1.jsx)(BudgetChange, { prevBudget: event.prevBudget, nextBudget: event.nextBudget, unit: unit }, void 0))] }, void 0));
};
const EventWrapper = styled_components_1.default.div `
  & > div:first-of-type {
    display: flex;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    & > p:first-of-type {
      flex: 2;
    }

    & > p:last-of-type {
      flex: 1;

      @media (max-width: ${({ theme }) => theme.utils.breakpoints.phone}) {
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
      }
    }

    & > div {
      display: flex;
      flex: 2;
      justify-content: space-between;

      p {
        padding-right: ${({ isCollapsable }) => isCollapsable ? "0" : "1.5rem"};
      }
    }
  }

  div p + svg {
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.m}`};
    }
  }
`;
const hasScroll = (elRef) => { var _a, _b; return (((_a = elRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0) > (((_b = elRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0); };
const Content = ({ events, unit }) => {
    const [isScroll, setIsScroll] = (0, react_1.useState)(false);
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        setIsScroll(hasScroll(containerRef));
    }, []);
    return ((0, jsx_runtime_1.jsx)(Container, { ref: containerRef, isScroll: isScroll, children: events.map((event) => ((0, jsx_runtime_1.jsx)(Event, { event: event, unit: unit }, event.id))) }, void 0));
};
exports.Content = Content;
const Container = styled_components_1.default.div `
  height: calc(100% - 100px);
  overflow: auto;

  & > div:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  }

  & > div > div > p:first-of-type {
    padding-right: ${({ isScroll, theme }) => isScroll ? theme.spacings.s : "0px"};
  }

  & > div > div > p:last-of-type {
    padding-right: ${({ isScroll, theme }) => isScroll ? theme.spacings.xs : "0px"};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div > div {
      column-gap: ${({ theme }) => theme.spacings.xxs};
    }

    & > div > div > p:first-of-type {
      padding-right: 0;
    }

    & > div > div > p:last-of-type {
      padding-right: 0;
    }
  }
`;
//# sourceMappingURL=Content.js.map